export default __webpack_public_path__ + "static/media/freeline.71e6d51b.jpeg";